import * as Immutable from 'immutable';

export type Locale = 'en_CA'|'fr_CA';
export type Currency = 'USD'|'CAD';
export type MeasurementSystem = 'imperial'|'metric';
export type ProductLayoutType = 'grid'|'list'
export type ProductSortType = 'n-to-o'|'o-to-n'|'a-to-z'|'z-to-a'

export interface UserPrefsPayload {
	currency: Currency,
	lang: Locale,
	measurementSystem?: MeasurementSystem
	addressAtCheckout?: boolean
	quickDeleteFromCart?: boolean
	massDesignLabSaveDismissed?: boolean
	accountProductsLayout?: ProductLayoutType
	accountProductsSort?: ProductSortType
	accountPageLimit?: number
}
export interface IUserPrefsStore {
	currency: Currency,
	lang: Locale,
	measurementSystem: MeasurementSystem,
	addressAtCheckout: boolean,
	quickDeleteFromCart: boolean,
	massDesignLabSaveDismissed: boolean,
	accountProductsLayout: ProductLayoutType,
	accountProductsSort: ProductSortType,
	accountPageLimit: number,
}

const defaultStore = Immutable.Record<IUserPrefsStore>({
	currency: 'USD',
	lang: 'en_CA',
	measurementSystem: 'imperial',
	addressAtCheckout: false,
	quickDeleteFromCart: false,
	massDesignLabSaveDismissed: false,
	accountProductsLayout: 'grid',
	accountProductsSort: 'n-to-o',
	accountPageLimit: 20,
});

export default class UserPrefsStore extends defaultStore implements IUserPrefsStore {}
